import { render, staticRenderFns } from "./AddLessons.vue?vue&type=template&id=7ed1f5be&scoped=true&"
import script from "./AddLessons.vue?vue&type=script&lang=js&"
export * from "./AddLessons.vue?vue&type=script&lang=js&"
import style0 from "./AddLessons.vue?vue&type=style&index=0&id=7ed1f5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed1f5be",
  null
  
)

export default component.exports